import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFilledCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
		fill: "currentColor"
	})
});
export { SvgIconFilledCircle as ReactComponent };
